import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Name } from 'libs/shared/model/src/lib/types/name.type';

import { transformNameToDisplayName } from '../name.util';

@Pipe({
  name: 'name',
  standalone: true,
})
export class NamePipe implements PipeTransform {
  private translocoService = inject(TranslocoService);

  transform(name: Name): string {
    const externalLabel = this.translocoService.translate('External');

    return transformNameToDisplayName(name, externalLabel);
  }
}
